module.exports = "<abc-header></abc-header>\n<router-outlet></router-outlet>\n<abc-footer></abc-footer>\n\n\n"